export const HR = () => {
  return <div className='hr-glow-line' />
}
